var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImagePrepSettingsComp_1;
import { Component, Model, Ref, Vue } from 'vue-property-decorator';
import { getDefaultPrepSettings, ImageFileType, userHasRoles, UserRoles } from '@ht-lib/accounts-models';
import ImagePrepPresetModal from './ImagePrepPresetModal.vue';
import ImagePrepInputs from './ImagePrepInputs.vue';
import { cloneDeep, merge } from 'lodash';
import { ImagePrepPreset } from '@ht-web/firebase-adapter';
let ImagePrepSettingsComp = ImagePrepSettingsComp_1 = class ImagePrepSettingsComp extends Vue {
    constructor() {
        super(...arguments);
        this.dpi = 0;
        this.fileTypeOptions = Object.values(ImageFileType);
        this.showAdvanced = false;
        this.presets = [];
        this.activePreset = null;
        this.loading = true;
        this.canManagePresets = false;
    }
    changePreset(c) {
        this.activePreset = c;
        if (c) {
            this.$emit('input', cloneDeep(c.settings));
        }
        else {
            this.$emit('input', getDefaultPrepSettings());
        }
    }
    update(c) {
        this.$emit('input', cloneDeep(merge(this.prep, c)));
    }
    editPreset() {
        if (!this.canManagePresets)
            return;
        this.presetModal.showModal(this.activePreset);
    }
    addPreset() {
        if (!this.canManagePresets)
            return;
        this.presetModal.showModal(null);
    }
    userCanManagePresets() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const auth = (_a = this.$auth) !== null && _a !== void 0 ? _a : null;
        if (auth === null) {
            return false;
        }
        const profile = auth.user.profile;
        const hasRole = userHasRoles(profile, ImagePrepSettingsComp_1.presetManagers.roles);
        const isAllowedUser = ImagePrepSettingsComp_1.presetManagers.users.includes(profile.email);
        return hasRole || isAllowedUser;
    }
    beforeDestroy() {
        this.snap();
    }
    created() {
        this.snap = ImagePrepPreset.listen((data) => {
            this.presets = data.sort((a, b) => a.name.localeCompare(b.name));
            this.loading = false;
        });
        this.canManagePresets = this.userCanManagePresets();
    }
};
ImagePrepSettingsComp.presetManagers = {
    users: [
        'a.otto@htempest.co.uk',
        'm.ruck@htempest.co.uk',
        's.wilkinson@htempest.co.uk'
    ],
    roles: [UserRoles.SOFTWARE_GODS, UserRoles.IMAGE_PRESET_MANAGER]
};
__decorate([
    Model('input')
], ImagePrepSettingsComp.prototype, "prep", void 0);
__decorate([
    Ref()
], ImagePrepSettingsComp.prototype, "presetModal", void 0);
ImagePrepSettingsComp = ImagePrepSettingsComp_1 = __decorate([
    Component({
        name: 'ImagePrepSettingsComp',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        components: { ImagePrepPresetModal, ImagePrepInputs }
    })
], ImagePrepSettingsComp);
export default ImagePrepSettingsComp;
